import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../helpers"
import { Context, StudyPlanTargets, Transitions } from "../types"
import { setRedirectUrl } from "../actions/setRedirectUrl"

export const getRecommendedPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getRecommendedPlan",
    src: "getRecommendedPlan",
    onDone: [
      {
        target: "#StudyPlan.review_plan",
        actions: [
          assign((ctx, evt, meta) => {
            if (ctx.previousParentState !== "landing_view") {
              return setRedirectUrl(
                ctx,
                evt,
                meta,
                StudyPlanTargets.ViewRecommended
              )
            }
          }),
          assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => ({
            // REVIEW: would be better to save separately, in "recommendedPlan"?
            currentTarget: StudyPlanTargets.ViewRecommended,
            recommendedStudyPlan: evt.data?.plan
          }))
        ]
      }
    ],
    onError: {
      target: "#StudyPlan.review_plan",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("getRecommendedPlan", {
            messageData: ["get recommended study plan"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
